import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=04da1048&scoped=true"
import script from "./AreaSelect.vue?vue&type=script&lang=js"
export * from "./AreaSelect.vue?vue&type=script&lang=js"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=04da1048&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da1048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04da1048')) {
      api.createRecord('04da1048', component.options)
    } else {
      api.reload('04da1048', component.options)
    }
    module.hot.accept("./AreaSelect.vue?vue&type=template&id=04da1048&scoped=true", function () {
      api.rerender('04da1048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/SettleFlod/Child/AreaSelect.vue"
export default component.exports